/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { DrawerGroupList } from '@components/systems/drawerMenu/DrawerGroupList'
import { List } from '@mui/material'

import { grey } from '@mui/material/colors'
import { useAppSelector, MenuType, UserMenuAccessType } from '@redux/index'
import { AccessControlManager } from '@guards'

export const DrawerMenuList = () => {
	// redux state
	const isOpenDrawer: boolean = useAppSelector(state => state.config.isOpenDrawer)
	const mode: 'main' | 'admin' = useAppSelector(state => state.config.mode)
	const mainMenu: MenuType[] = useAppSelector(state => state.main.menu)
	const adminMenu: MenuType[] = useAppSelector(state => state.admin.menu)
	const userAccessMenuList: UserMenuAccessType[] = useAppSelector(
		state => state.auth.userAccessMenuList,
	)

	const menu = React.useMemo(
		() =>
			AccessControlManager.getMainMenuList({
				mode: mode,
				userAccessMenuList: userAccessMenuList,
				mainMenu: mainMenu,
				adminMenu: adminMenu,
			}),
		[mode, userAccessMenuList, mainMenu, adminMenu],
	)

	return (
		<List css={[style, isOpenDrawer ? { background: grey[50] } : null]}>
			{menu.map((aMenu: MenuType) => (
				<DrawerGroupList key={`first-${aMenu.id}`} menu={aMenu} />
			))}
		</List>
	)
}

const style = css({
	width: '100%',
	overflow: 'hidden',
})
